import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { FiXCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { cancelIsusu, fetchIsusu } from "../../../redux/slices/isusuSlice";

export default function CancelIsusu({ id, name }) {
  const [showModal, setShowModal] = useState(false);
  const statusCancel = useSelector((state) => state.isusu.statusCancelIsusu); // adjust slice name
  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelIsusu(id)).unwrap();
      await dispatch(fetchIsusu());

      // Access message from response.data
      toast.success(res.data?.message || "Isusu cancelled successfully");
      setShowModal(false);
    } catch (error) {
      toast.error(error?.message || "Failed to delete isusu group");
      console.error(error);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="hover:shadow-lg"
      >
        <FiXCircle className="text-xl text-gray-600 hover:text-red-600" />
      </button>

      {showModal && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full max-w-md mx-auto my-6">
              <div className="border-0 rounded-lg p-6 shadow-lg bg-white relative flex flex-col outline-none focus:outline-none">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-3 text-gray-400 hover:text-gray-900"
                >
                  <FaTimes className="text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className="space-y-4">
                  <h1 className="text-2xl text-center text-gray-800 font-semibold">
                    Cancel Isusu
                  </h1>
                  <p className="text-center text-gray-700 text-sm sm:text-base leading-relaxed">
                    Are you sure you want to cancel the isusu{" "}
                    <strong className="text-red-600 font-semibold">
                      "{name}"
                    </strong>
                    ?<br />
                    <span className="text-gray-500">
                      This action is irreversible and will permanently remove
                      this isusu.
                    </span>
                  </p>
                </div>

                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 text-sm font-semibold bg-gray-100 text-gray-700 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCancel}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-red-600 text-white rounded-lg"
                    disabled={statusCancel === "loading"}
                  >
                    {statusCancel === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Canceling...
                      </>
                    ) : (
                      "Cancel Isusu"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black opacity-25 z-40"></div>
        </>
      )}
    </>
  );
}
